module.exports = __webpack_public_path__ + "static/media/missions.ccbc8149.png";